module.exports = __webpack_public_path__ + "static/img/page2.7e0b963.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recordPublicity/page2.jpg
// module id = HK+x
// module chunks = 28 80